const angular = require('angular');

const BwsNotificationService = function ($timeout, $http, $compile, $templateCache, $rootScope, $injector, $sce, $q, $window) {
    this.$timeout = $timeout;
    this.$http = $http;
    this.$compile = $compile;
    this.$templateCache = $templateCache;
    this.$rootScope = $rootScope;
    this.$injector = $injector;
    this.$sce = $sce;
    this.$q = $q;
    this.$window = $window;

    const options = {
        delay: 5000,
        startTop: 80,
        startRight: 10,
        verticalSpacing: 10,
        horizontalSpacing: 10,
        positionX: 'right',
        positionY: 'top'
    };

    const startTop = options.startTop;
    const startRight = options.startRight;
    const verticalSpacing = options.verticalSpacing;
    const horizontalSpacing = options.horizontalSpacing;
    const delay = options.delay;

    const messageElements = [];
    let isResizeBound = false;

    const notify = function (args, t) {
        const deferred = $q.defer();

        if (typeof args !== 'object') {
            args = { message: args };
        }

        args.scope = args.scope ? args.scope : $rootScope;
        args.delay = !angular.isUndefined(args.delay) ? args.delay : delay;
        args.type = t || options.type || '';
        args.positionY = args.positionY ? args.positionY : options.positionY;
        args.positionX = args.positionX ? args.positionX : options.positionX;
        args.replaceMessage = args.replaceMessage ? args.replaceMessage : options.replaceMessage;

        const template = '<div class="animated bounceInRight bws-notification"><h3 ng-show="title" ng-bind-html="title"></h3><div class="message" ng-bind-html="message"></div></div>';

        const scope = args.scope.$new();
        scope.message = $sce.trustAsHtml(args.message);
        scope.title = $sce.trustAsHtml(args.title);
        scope.t = args.type.substr(0, 1);
        scope.delay = args.delay;

        const reposite = function () {
            let j = 0;
            let k = 0;
            const lastRight = startRight;
            const lastPosition = [];
            for (let i = messageElements.length - 1; i >= 0; i--) {
                const element = messageElements[i];
                if (args.replaceMessage && i < messageElements.length - 1) {
                    element.addClass('killed');
                    continue;
                }
                const elHeight = parseInt(element[0].offsetHeight);
                const elWidth = parseInt(element[0].offsetWidth);
                let position = lastPosition[element._positionY + element._positionX];
                const top = (position ? (j === 0 ? position : position + verticalSpacing) : startTop);

                if ((top + elHeight) > window.innerHeight) {
                    position = startTop;
                    k++;
                    j = 0;
                }

                const right = lastRight + (k * (horizontalSpacing + elWidth));

                element.css(element._positionY, top + 'px');
                if (element._positionX === 'center') {
                    element.css('left', parseInt(window.innerWidth / 2 - elWidth / 2) + 'px');
                } else {
                    element.css(element._positionX, right + 'px');
                }

                lastPosition[element._positionY + element._positionX] = top + elHeight;

                j++;
            }
        };

        const templateElement = $compile(template)(scope);
        templateElement._positionY = args.positionY;
        templateElement._positionX = args.positionX;
        templateElement.addClass(args.type);
        templateElement.bind('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd click', function (e) {
            e = e.originalEvent || e;
            if (e.type === 'click' || (e.propertyName === 'opacity' && e.elapsedTime >= 1)) {
                templateElement.remove();
                messageElements.splice(messageElements.indexOf(templateElement), 1);
                scope.$destroy();
                reposite();
            }
        });
        if (angular.isNumber(args.delay)) {
            $timeout(function () {
                templateElement.addClass('killed');
            }, args.delay);
        }

        angular.element(document.getElementsByTagName('bws-notification')).append(templateElement);
        const offset = -(parseInt(templateElement[0].offsetHeight) + 50);
        templateElement.css(templateElement._positionY, offset + 'px');
        messageElements.push(templateElement);

        scope._templateElement = templateElement;

        scope.kill = function (isHard) {
            if (isHard) {
                messageElements.splice(messageElements.indexOf(scope._templateElement), 1);
                scope._templateElement.remove();
                scope.$destroy();
                $timeout(reposite);
            } else {
                scope._templateElement.addClass('killed');
            }
        };

        $timeout(reposite);

        if (!isResizeBound) {
            angular.element($window).bind('resize', function (e) {
                e = e + '1';
                $timeout(reposite);
            });
            isResizeBound = true;
        }

        deferred.resolve(scope);

        return deferred.promise;
    };

    notify.primary = function (args) {
        return this(args, 'primary');
    };
    notify.error = function (args) {
        return this(args, 'error');
    };
    notify.success = function (args) {
        return this(args, 'success');
    };
    notify.info = function (args) {
        return this(args, 'info');
    };
    notify.warning = function (args) {
        return this(args, 'warning');
    };

    notify.clearAll = function () {
        angular.forEach(messageElements, function (element) {
            element.addClass('killed');
        });
    };

    return notify;
};

module.exports = BwsNotificationService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/notification/bws-notification-service.js
 **/